var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectGoals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.965 65.1865C75.955 64.8515 73.98 66.1815 73.615 68.2215C73.255 70.2615 74.61 72.2065 76.65 72.5715C92.36 75.3665 100.575 81.5315 100.575 86.1665C100.575 93.2865 83.235 101.247 60.025 101.247C36.7901 101.247 19.425 93.2865 19.425 86.1665C19.425 81.5615 27.6501 75.4115 43.365 72.5665C45.4001 72.1965 46.7551 70.2465 46.385 68.2065C46.015 66.1715 44.065 64.8215 42.03 65.1865C23.46 68.5515 11.925 76.5865 11.925 86.1665C11.925 99.0415 32.605 108.747 60.025 108.747C87.42 108.747 108.075 99.0415 108.075 86.1665C108.075 76.5365 96.54 68.4965 77.965 65.1865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.001 87.2995C62.071 87.2995 63.751 85.6195 63.751 83.5495V48.3746L87.306 47.9296C88.941 47.8996 90.366 46.8146 90.836 45.2446L96.026 27.7496C96.591 25.8446 95.571 23.8296 93.701 23.1546L61.271 11.4696C60.116 11.0596 58.846 11.2296 57.846 11.9296C56.846 12.6346 56.251 13.7796 56.251 14.9996V83.5495C56.251 85.6195 57.931 87.2995 60.001 87.2995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectGoals);
export default __webpack_public_path__ + "static/media/select_goals.f09e90766216d95a9bbc6058f7df5586.svg";
export { ForwardRef as ReactComponent };